import { TestContext } from '../models/data';
import BaseService from './BaseService';

export class TestContextService extends BaseService {
  async get(): Promise<TestContext> {
    return (await this.getJson<TestContext>('/test-context')).data;
  }

  async set(testDate: string): Promise<TestContext> {
    return (await this.putJson<TestContext>('/test-context', { testDate })).data;
  }

  async clear(): Promise<void> {
    await this.deleteJson('/test-context');
  }
}

export default new TestContextService();
